import { FilterValueType, instanceOfOptionValueArray, instanceOfRangeValue, RangeValue } from 'festo-react-ui-kit';
import { FilterBaseType } from '../../type/FilterBaseType';
import { getValueData } from './filterUtils';

function countDecimals(value: number): number {
  if (Math.floor(value) === value) return 0;
  return value.toString().split('.')[1].length || 0;
}

function getSteps(rangeValue: RangeValue<number>) {
  const { steps, max, min, step } = rangeValue;
  let innerSteps: number[] = [];
  const innerStep = step || 1;
  if (steps) {
    innerSteps = steps;
  } else {
    for (let i = min; i <= max; i += innerStep) {
      const precision = countDecimals(innerStep);
      const newStep = Number.parseFloat(i.toFixed(precision));
      innerSteps.push(newStep);
    }
  }
  return innerSteps;
}
export function getAdjustedRangeValue(
  currentValue: RangeValue<number>,
  targetValue: RangeValue<number>,
): RangeValue<number> {
  const rawData = currentValue.data;
  const innerSteps = getSteps(targetValue);
  if (currentValue !== undefined && !innerSteps.includes(rawData)) {
    for (let i = 0; i < innerSteps.length; i += 1) {
      if (innerSteps[i] > rawData) {
        const updatedValue = innerSteps[i > 0 ? i - 1 : 0];
        return { ...targetValue, data: updatedValue };
      }
    }
    return { ...targetValue, data: innerSteps[innerSteps.length - 1] };
  }
  return { ...targetValue, data: rawData };
}
function getAdjustedTargetValue(
  targetFilter: FilterBaseType,
  targetValue: FilterValueType | FilterValueType[],
): FilterValueType | FilterValueType[] | undefined {
  const currentValue = targetFilter.value;
  if (instanceOfRangeValue(targetValue) && currentValue && instanceOfRangeValue(currentValue)) {
    return getAdjustedRangeValue(currentValue, targetValue);
  }
  return targetFilter.value;
}

export function applyRules(
  value: React.ReactText[],
  filters: Record<string, FilterBaseType>,
  sourceFilter: FilterBaseType,
): void {
  if (sourceFilter.rules) {
    sourceFilter.rules.forEach((rule) => {
      if (value.includes(rule.valueSet)) {
        const targetFilter = filters[rule.targetId];
        if (rule.type === 'FILTER') {
          // eslint-disable-next-line no-param-reassign
          filters[rule.targetId].hidden = rule.hidden;
        } else {
          if (rule.type === 'FILTER_VALUE') {
            const values = filters[rule.targetId].value;
            if (values && instanceOfOptionValueArray(values)) {
              for (const valueId of rule.filterValueIds) {
                const value = values.find((value) => value.id === valueId);
                if (value) {
                  value.selected = true;
                  value.disabled = true;
                }
              }
            }
          } else {
            // eslint-disable-next-line no-param-reassign
            filters[rule.targetId].value = getAdjustedTargetValue(targetFilter, rule.targetValue);
          }
        }
      }
    });
  }
}

export function applyAllRules(keys: string[], filters: Record<string, FilterBaseType>): void {
  keys.forEach((key) => {
    const filter = filters[key];
    const data = getValueData(filter);
    if (data) {
      applyRules(data, filters, filter);
    }
  });
}
